// Update card (card at sign-up, phase 3): Stripe is opened ONLY to type a new card, a Checkout
// session in setup mode made by the server for the caller's own customer. Coming back, the address
// carries ?card_session=cs_..., and the server makes that card the default and pays a failed bill
// with it (POST /api/billing/card/confirm, safe to repeat). Used by Plan & billing and the paywall.
import { api } from '../api/client';

export async function startCardUpdate() {
  const res = await api('/api/billing/card/session', { method: 'POST' });
  const data = await res.json();
  window.location.assign(data.url);
}

const validId = (id) => (id && /^cs_[A-Za-z0-9_]+$/.test(id) ? id : null);
const readId = () => {
  try { return validId(new URLSearchParams(window.location.search || '').get('card_session')); } catch { return null; }
};

// READ WHEN THE APP LOADS. App.js cleans every query parameter off the address on its first render
// (its ?section= and OAuth return handler), before Plan & billing or the paywall mounts, so the id
// Stripe sent back would be gone by the time either looked. Kept here, handed out once. This module
// is loaded at start because App.js imports TrialPaywall, which imports it.
let returnedId = readId();

export function cardSessionFromUrl() {
  return readId() || returnedId;
}

// Removes card_session from the address (and the kept copy), so a refresh does not confirm the same
// return again (harmless, but it would repeat the message).
export function clearCardSessionFromUrl() {
  returnedId = null;
  try {
    const params = new URLSearchParams(window.location.search || '');
    if (!params.has('card_session')) return;
    params.delete('card_session');
    const q = params.toString();
    window.history.replaceState(window.history.state, '', `${window.location.pathname}${q ? `?${q}` : ''}`);
  } catch { /* a test double for location may have no history to replace */ }
}

export async function confirmCardReturn(sessionId) {
  const res = await api('/api/billing/card/confirm', { method: 'POST', body: JSON.stringify({ sessionId }) });
  return res.json();
}

// ── Phase 4: the billing emails' direct links ─────────────────────────────────────────────────
// /billing/cancel opens Plan & billing with the Cancel plan confirmation open; /billing/update-card
// opens Stripe's card form (Visa 5-21 and 5.8.17.2: a simple online way to cancel, from the email).
// Read when the app loads, for the same reason as card_session above: App rewrites the address on
// its first render, before Plan & billing mounts. Handed out until cleared, once acted on.
const INTENTS = { '/billing/cancel': 'cancel', '/billing/update-card': 'update-card' };
const readIntent = () => {
  try { return INTENTS[String(window.location.pathname || '').replace(/\/+$/, '')] || null; } catch { return null; }
};
let billingIntent = readIntent();

export function billingIntentFromUrl() {
  return readIntent() || billingIntent;
}

// Acted on: forgotten, and the address becomes /billing, so a refresh does not open it again.
export function clearBillingIntent() {
  billingIntent = null;
  try {
    if (readIntent()) window.history.replaceState(window.history.state, '', '/billing');
  } catch { /* a test double for location may have no history to replace */ }
}
